class Monitoring.Models.ContentEnhancer

  constructor: (@socialContent, text=null) ->
    @text = text || @socialContent.content() || ''
    @defaultOptions = {
      replaceHtmlTags: true, evidenceField: 'text', addAnchors: true, replaceLineBreaks: true, trim: false}

  getContent: (opt={}) ->
    options = $.extend(true, {}, @defaultOptions, opt)
    @evidences = $.extend(true, [], (@socialContent.getSortedEvidencesBy(options.evidenceField)))

    content = @text
    content = @replaceHtmlTags(content) if options.replaceHtmlTags
    content = @addEvidence(content) if options.evidenceField
    content = @socialContent.addAnchorsToLinks(content) if options.addAnchors
    content = @trim(content) if options.trim
    content = @replaceLineBreaks(content) if options.replaceLineBreaks

    content = "" if content == 'undefinedundefined' #TODO: prevent this possibility
    return "<span>#{content}</span>"

  trim: (text) ->
    return text.trim()

  replaceLineBreaks: (text) ->
    return text.replace(/\n/g, '</br>')

  addEvidence: (content) ->
    insertedEvidences = []
    for evidences in @evidences
      evidenceColorClass = @_getEvidenceClass(evidences[0])
      tooltips = _.pluck(evidences, 'tooltip').join(', ').replace(/'/g, '&#39;')
      tooltipWrapperStart = "<em rel='tooltip' title='#{tooltips}' class='evidence #{evidenceColorClass}'>"
      tooltipWrapperEnd = "</em>"
      end = @_getEndDependingOnPreviousEvidences(evidences[0], insertedEvidences)
      insertedEvidences.push(evidences[0].start)
      content =
        content.substring(0, evidences[0].start) +
          tooltipWrapperStart +
          content.substring(evidences[0].start, end) +
          tooltipWrapperEnd +
          content.substring(end, content.length)

    return content

  _getEvidenceClass: (evidence) ->
    colorClass = ''
    switch evidence.positiveness
      when 1
        colorClass = "green-highlight"
      when 2
        colorClass = "red-highlight"
      else
        colorClass = "yellow-highlight"

    return colorClass

  _getEndDependingOnPreviousEvidences: (evidence, previousEvidences) ->
    conflictedEvidence = _.filter(previousEvidences, (start) -> start < evidence.end)
    return if conflictedEvidence.length > 0 then _.min(conflictedEvidence) else evidence.end

  replaceHtmlTags: (content) ->
    newTextObj = { text: '', extraLength: 0 }

    for i in [0..@text.length - 1]
      if @text[i] == '<'
        @_addEncodedCharacter(newTextObj, i, '&lt;')
      else if @text[i] == '>'
        @_addEncodedCharacter(newTextObj, i, '&gt;')
      else
        newTextObj.text += @text[i]
    newTextObj.text

  _addEncodedCharacter: (newTextObj, index, encodedChar) ->
    newTextObj.text += encodedChar
    resize = encodedChar.length - @text[index].length
    implicatedEvidences = _.filter @evidences, (evidence) -> evidence[0].end >= index + newTextObj.extraLength
    _.each implicatedEvidences, (evidences) ->
      _.each evidences, (evidence) ->
        evidence.start += resize if evidence.start > (index + newTextObj.extraLength)
        evidence.end += resize
    newTextObj.extraLength += resize
